module.exports = __webpack_public_path__ + "img/icon_logout.0a9f6ba1.svg";